import { CreateRoadsideJobRequest } from '@/interfaces/entities/jor-create-rsa-job.interface';
import { RequestRoadsideAssistanceDetailsFleet } from '@/interfaces/pages/request-roadside-assistance.interface';

export const YOUR_DETAILS_VEHICLE_DETAILS_STEP_ID = 'vehicledetails';

export const REQUEST_FLEETCARE_ASSISTANCE = 'Request fleetcare assistance';

const RACQ_BATTERIES = 'RACQ Batteries';

export default {} as const;

export async function createRsaJobHtmlRequest(
  requestRoadsideAssistanceDetails: RequestRoadsideAssistanceDetailsFleet
): Promise<Partial<CreateRoadsideJobRequest>> {
  const baseRequest = createBaseRsaJob(requestRoadsideAssistanceDetails, 'HTML Fleetcare');

  return {
    ...baseRequest,
  } as CreateRoadsideJobRequest;
}

function createBaseRsaJob(
  requestRoadsideAssistanceDetails: RequestRoadsideAssistanceDetailsFleet,
  channel: string
): Partial<CreateRoadsideJobRequest> {
  return {
    channel: channel,
    comments: [requestRoadsideAssistanceDetails.comments],
    triageAnswers: {
      SAFE_LOCATION: ['NO'],
      BREAKDOWN_REASON: [requestRoadsideAssistanceDetails.breakdownCause],
    },
    membership: {
      membershipCardNumber: requestRoadsideAssistanceDetails.serviceNumber, // For fleet, service number is used as membership number
      contact: {
        phone: requestRoadsideAssistanceDetails.phoneNumber,
      },
    },
    vehicle: {
      colour: requestRoadsideAssistanceDetails.vehicle?.colour,
      make: requestRoadsideAssistanceDetails.vehicle?.make,
      model: requestRoadsideAssistanceDetails.vehicle?.model,
      registration: requestRoadsideAssistanceDetails.registrationNumber,
      buildYear: parseInt(requestRoadsideAssistanceDetails.vehicle?.buildYear as any, 10),
      batteries: mapBatteries(requestRoadsideAssistanceDetails.batteries!),
      location: {
        latitude: requestRoadsideAssistanceDetails.breakdownLocationLatitude,
        longitude: requestRoadsideAssistanceDetails.breakdownLocationLongitude,
        comment: requestRoadsideAssistanceDetails.breakdownLocationAddress,
      },
    },
  } as unknown as Partial<CreateRoadsideJobRequest>;
}

function mapBatteries(batteries: string): string {
  if (batteries?.toLowerCase() === RACQ_BATTERIES.toLowerCase()) {
    return 'Yes - Fleet';
  }
  return batteries;
}
